export default defineNuxtPlugin(async (nuxtApp) => {
    const config = useRuntimeConfig()
    const router = useRouter()
    const Sentry = await import('@sentry/vue')
    const { BrowserTracing } = await import('@sentry/tracing')
    // is Sentry loggin enabled?
    if (!config.public.SENTRY_LOGGING) return
    // get Vue app
    const { vueApp } = nuxtApp
    // init Sentry
    Sentry.init({
        app: vueApp,
        dsn: config.public.SENTRY_DSN,
        release: config.public.SENTRY_RELEASE as string,
        integrations: [
            new BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracePropagationTargets: [/^\//],
            }) as never,
        ],
        environment: config.public.APP_ENVIRONMENT as string || 'dev',
        tracesSampleRate: Number(config.public.SENTRY_TRACES_SAMPLE_RATE),
    })
})
